import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {MCS_TARGET_SYSTEMS, TARGET_SYSTEM} from "../helpers/app-constants";

interface DartDealResponse {
  success?: boolean;
  withoutNetPriceSolutionIdsDartDealNumber?: {
    dartDeal: string[];
    devicesWithoutValidSKUBA: string[];
    devicesWithoutValidNetPrice: string[];
  };
}

@Injectable()
export class DartAPIService {
  private url: string = "/api/DartAPI";

  constructor(private http: HttpClient) {}
  async importDartDealById(dartDealId: string, targetSystem: string, projectId?: string, continueToImport: boolean = false): Promise<any> {
    if (!dartDealId || typeof dartDealId !== "string") throw new Error("DART Deal ID should be provided");

    const params: any = {dartDealId, targetSystem, continueToImport};

    if (projectId && typeof projectId === "string") {
      params.projectId = projectId;
    }
    return this.http.get<DartDealResponse>(`${this.url}/import-dart-deal`, {params})
      .pipe(map(json => (
        {
          success: !!json.success,
          withoutNetPriceSolutionIdsDartDealNumber: json.withoutNetPriceSolutionIdsDartDealNumber ||
          {dartDeal: [], devicesWithoutValidSKUBA: [], devicesWithoutValidNetPrice: []},
        })))
      .toPromise();
  }

  async importDaasDartDealById(dartDealId: string, projectId?: string, targetSystem?: string, source?: string): Promise<any> {

    if ((!dartDealId || typeof dartDealId !== "string")) {
      if (typeof targetSystem !== 'undefined' && MCS_TARGET_SYSTEMS.includes(targetSystem)) {
        throw new Error("MCS DART Deal ID should be provided");
      } else if (typeof targetSystem !== 'undefined' && targetSystem === TARGET_SYSTEM.DIGITAL_SERVICE) {
        throw new Error("DS DART Deal ID should be provided");
      } else {
        throw new Error("DAAS DART Deal ID should be provided");
      }
    }

    const params: any = {dartDealId};

    if (projectId && typeof projectId === "string") {
      params.projectId = projectId;
    }
    params.source = source || "DAAS";
    return this.http.get<{success: boolean}>(`${this.url}/import-daas-dart-deal`, {params})
      .pipe(map(json => ({success: !!json.success})))
      .toPromise();
  }
}
